<span>
  &copy; {{ settings.app.year }} - {{ settings.app.name }}<br />
  <a class="small mr" href="http://in2l.com/privacy-policy/" target="_blank"
    >Privacy Policy</a
  >
  <a class="small ml" href="http://in2l.com/terms-of-use/" target="_blank"
    >Terms of Use</a
  >
</span>
